import {AccordionCustom as Accordion} from '@/components/molecules/AccordionCustom'
import {ComboReviewDisplay} from './ComboReviewDisplay'
import {ComboReviewProducts} from './ComboReviewProducts'
import {ComboReviewSetup} from './ComboReviewSetup'

export const ProductComboReview = () => {
  return (
    <div className="promotions-review w-full overflow-hidden">
      <Accordion
        isDark
        size="large"
        presentation="box-shadow"
        className="font-body w-full"
        content={
          <div className="flex w-full flex-col gap-4">
            <ComboReviewSetup />
            <ComboReviewDisplay />
            <ComboReviewProducts />
          </div>
        }
      />
    </div>
  )
}
